import dayjs from 'dayjs';
import { ENV } from '../utils/environment';

export const Copyright = () => (
  <div className="copyright">
    {ENV.CLIENT_NAME} © {dayjs().format('YYYY')}
  </div>
);
